__turbopack_context__.v({
  "band": "DarkBand-module__8yqmHG__band",
});
